module.exports = __webpack_public_path__ + "img/status-completed-active.8839b2d8.svg";